import Vue from 'vue'
import Router from 'vue-router'

import index from '@/components/index'
import blocks from '@/components/block/blocks'
import block from '@/components/block/block'
import peers from '@/components/peer/peers'
import peer from '@/components/peer/peer'

import generators from '@/components/generators'
import account from '@/components/account/account'
import accounts from '@/components/account/index'
import alias from '@/components/alias/index'
import asset from '@/components/asset/index'
import assetAccounts from '@/components/asset/account'

import currency from '@/components/currency/index'
import peersMap from '@/components/peer/peersMap'
import peers3d from '@/components/peer/peers3d'
import api from '@/components/api/index'
import transaction from '@/components/transaction/index'
import fc from '@/components/fc'

import review from '@/components/review'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/fc',
            name: 'fc',
            component: fc
        },
        {
            path: '/api',
            name: 'api',
            component: api
        },
        {
            path: '/blocks',
            name: 'blocks',
            component: blocks
        },
        {
            path: '/block/:height',
            name: 'block',
            component: block
        },
        {
            path: '/peer',
            name: 'peer',
            component: peer
        },
        {
            path: '/peers',
            name: 'peers',
            component: peers
        },
        {
            path: '/generators',
            name: 'generators',
            component: generators
        }
        ,
        {
            path: '/account/:account',
            name: 'account',
            component: account
        },
        {
            path: '/accounts',
            name: 'accounts',
            component: accounts
        },
        {
            path: '/alias',
            name: 'alias',
            component: alias
        },
        {
            path: '/asset',
            name: 'asset',
            component: asset
        },
        {
            path: '/assetaccounts/:account',
            name: 'assetaccounts',
            component: assetAccounts
        },

        {
            path: '/currency',
            name: 'currency',
            component: currency
        },
        {
            path: '/peersMap',
            name: 'peersMap',
            component: peersMap
        }
        ,
        {
            path: '/peers3d',
            name: 'peers3d',
            component: peers3d
        },
        {
            path: '/review',
            name: 'review',
            component: review
        },
        {
            path: '/transaction/:transaction',
            name: 'transaction',
            component: transaction
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js